import { HelmetDexteel } from "@dexteel/mesf-core";
import { BilletWorkOrdersMasterDetail } from "./components/BilletWorkOrdersMasterDetail";

export const BilletWorkOrdersPage = () => {
	return (
		<>
			<HelmetDexteel title="Billet Work Orders" />
			<BilletWorkOrdersMasterDetail />
		</>
	);
};
